import { useContext } from 'react';

import { ReviewRequestDialogContext } from '../context';

const useReviewRequestDialog = () => {
  const context = useContext(ReviewRequestDialogContext);

  if (!context) {
    throw new Error(
      'useReviewRequestDialog must be used within a ReviewRequestDialogProvider'
    );
  }

  return context;
};

export default useReviewRequestDialog;
